import React from 'react';
import { APP_STORE_URL, HOME_REDESIGN_IMAGES, PLAY_STORE_URL } from './constants';
import { IconApple, IconGooglePlayMark } from './HomeRedesignIcons';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

const HomeRedesignFinalCta: React.FC = () => {
  const f = useHomeRedesignStrings().finalCta;

  return (
    <section className="container-chisme py-10 lg:py-16">
      <div
        className="flex flex-col items-center gap-10 overflow-hidden rounded-[40px] px-6 py-10 sm:px-10 sm:py-12 lg:flex-row lg:justify-between lg:gap-12 lg:px-16 lg:py-[72px]"
        style={{
          backgroundImage:
            'linear-gradient(129deg, rgb(255, 217, 238) 0%, rgb(255, 192, 225) 100%)',
        }}
      >
        <div className="flex max-w-xl flex-col gap-6 lg:max-w-[540px] lg:justify-between">
          <h2 className="font-instrument text-4xl leading-[1.05] tracking-[-0.03em] text-[#2a0f2a] sm:text-6xl lg:text-[110px] lg:leading-[0.88] lg:tracking-[-0.03em]">
            <span className="block">{f.h2a}</span>
            <span className="block italic text-chisme-primary">{f.h2b}</span>
            <span className="block italic text-chisme-primary">{f.h2c}</span>
          </h2>
          <div>
            <p className="font-jakarta text-base leading-relaxed text-[#5a3158] lg:text-lg lg:leading-[26px]">
              {f.body}
            </p>
            <div className="mt-5 flex flex-wrap gap-2.5">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-[54px] items-center gap-2.5 rounded-[14px] bg-[#2a0f2a] px-4 font-jakarta text-white"
              >
                <IconApple className="size-6 shrink-0 text-white" />
                <span className="flex flex-col items-start leading-tight">
                  <span className="text-[10px] font-medium opacity-75">{f.downloadOn}</span>
                  <span className="text-base font-bold tracking-[-0.01em]">{f.appStore}</span>
                </span>
              </a>
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex h-[54px] items-center gap-2.5 rounded-[14px] bg-[#2a0f2a] px-4 font-jakarta text-white"
              >
                <IconGooglePlayMark className="size-6 shrink-0" />
                <span className="flex flex-col items-start leading-tight">
                  <span className="text-[10px] font-medium opacity-75">{f.getItOn}</span>
                  <span className="text-base font-bold tracking-[-0.01em]">{f.googlePlay}</span>
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="relative w-full max-w-[320px] shrink-0 rotate-2 sm:max-w-[380px] lg:max-w-[420px]">
          <div className="relative aspect-[420/500] w-full overflow-hidden rounded-2xl shadow-[0px_30px_70px_rgba(74,33,71,0.18)]">
            <img
              src={HOME_REDESIGN_IMAGES.ctaPhoto}
              alt=""
              className="absolute inset-0 size-full object-cover"
            />
            <div className="absolute bottom-3 left-3 rounded bg-white/55 px-1.5 py-0.5 backdrop-blur-sm">
              <p className="font-jetbrains text-[10px] uppercase tracking-[0.36px] text-[rgba(74,33,71,0.6)]">
                {f.photoBadge}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeRedesignFinalCta;
